/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getStructDecoder,
  getStructEncoder,
  getU64Decoder,
  getU64Encoder,
  type Address,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

export type EvtClaimProtocolFee = {
  pool: Address;
  tokenAAmount: bigint;
  tokenBAmount: bigint;
};

export type EvtClaimProtocolFeeArgs = {
  pool: Address;
  tokenAAmount: number | bigint;
  tokenBAmount: number | bigint;
};

export function getEvtClaimProtocolFeeEncoder(): FixedSizeEncoder<EvtClaimProtocolFeeArgs> {
  return getStructEncoder([
    ["pool", getAddressEncoder()],
    ["tokenAAmount", getU64Encoder()],
    ["tokenBAmount", getU64Encoder()],
  ]);
}

export function getEvtClaimProtocolFeeDecoder(): FixedSizeDecoder<EvtClaimProtocolFee> {
  return getStructDecoder([
    ["pool", getAddressDecoder()],
    ["tokenAAmount", getU64Decoder()],
    ["tokenBAmount", getU64Decoder()],
  ]);
}

export function getEvtClaimProtocolFeeCodec(): FixedSizeCodec<
  EvtClaimProtocolFeeArgs,
  EvtClaimProtocolFee
> {
  return combineCodec(
    getEvtClaimProtocolFeeEncoder(),
    getEvtClaimProtocolFeeDecoder(),
  );
}
